import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectComponent';
import MultiSelect from '../../../Selects/MultiSelect';

function Manutencao({
    editarProposta,
    tipoContrato,
    setTipoContrato,
    arrayTipoContrato,
    lubrificantes,
    setLubrificantes,
    arrayLubrificantes,
    duracaoContrato,
    setDuracaoContrato,
    arrayDuracaoContrato,
    arrayHorasAno,
    horasAno,
    setHorasAno,
    localTrabalho,
    setLocalTrabalho,
    setOnChangeForm,
}) {
    const {t} = useTranslation();
    console.log(arrayDuracaoContrato, "aqui");
    return (
        <form className="mt-4">
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('tipoContrato')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarProposta}
                        options={arrayTipoContrato}
                        value={tipoContrato}
                        onChange={e => {
                            setTipoContrato(e);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                        isClearable={true}
                    />
                </div>
                <div>
                    <label htmlFor="phone" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white `}>
                        {t('lubrificantes')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarProposta}
                        options={arrayLubrificantes}
                        value={lubrificantes}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLubrificantes(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                        isClearable={true}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('duracaoContrato')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarProposta}
                        options={arrayDuracaoContrato}
                        value={duracaoContrato}
                        onChange={e => {
                            setDuracaoContrato(e);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                        isClearable={true}
                    />
                </div>
                <div>
                    <label htmlFor="phone" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white `}>
                        {t('horasAno')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarProposta}
                        options={arrayHorasAno}
                        value={horasAno}
                        onChange={e => {
                            setOnChangeForm(true);
                            setHorasAno(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                        isClearable={true}
                    />
                </div>
            </div>
            <div>
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('localTrabalho')}
                </label>
                <input
                    // type="number"
                    value={localTrabalho}
                    className={`${
                        !editarProposta ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                    }  border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                    onChange={e => {
                        setLocalTrabalho(e.target.value);
                        setOnChangeForm(true);
                    }}
                    required
                    disabled={!editarProposta}
                />
            </div>
        </form>
    );
}

export default Manutencao;
